import { render, staticRenderFns } from "./BaseFieldset.vue?vue&type=template&id=615e14c1"
import script from "./BaseFieldset.vue?vue&type=script&lang=js"
export * from "./BaseFieldset.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldset.vue?vue&type=style&index=0&id=615e14c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports